export class RunningMax {
  private _lastMax: number = -Infinity;

  public addValue(value: number): void {
    if (value > this._lastMax) {
      this._lastMax = value;
    }
  }

  public reset(): number {
    const lastMaxCache: number = this._lastMax;
    this._lastMax = -Infinity;
    return lastMaxCache;
  }

  get max(): number {
    return this._lastMax;
  }
}
